import { LANGS } from "@/i18n/t";
import { useI18n } from "@/i18n/use-i18n";
import { cn } from "@/lib/cn";

/**
 * DE | EN segmented switch.
 *
 * `tone` exists because the two places it appears sit on opposite backgrounds:
 * the navy topbar and the white auth card.
 */
export function LanguageToggle({ tone = "dark" }: { tone?: "dark" | "light" }) {
  const { lang, setLang, t } = useI18n();

  return (
    <div
      role="group"
      aria-label={t("lang.label")}
      className={cn(
        "flex shrink-0 items-center gap-0.5 rounded-full p-0.5",
        tone === "dark" ? "bg-white/12" : "bg-page",
      )}
    >
      {LANGS.map((option) => (
        <button
          key={option}
          type="button"
          aria-pressed={lang === option}
          onClick={() => setLang(option)}
          className={cn(
            "min-h-11 min-w-11 rounded-full px-2.5 text-[11.5px] font-semibold transition-colors sm:min-h-0 sm:min-w-0 sm:py-1",
            lang === option
              ? tone === "dark"
                ? "bg-white text-navy-deep"
                : "bg-surface text-ink shadow-card"
              : tone === "dark"
                ? "text-white/70 hover:text-white"
                : "text-muted hover:text-ink",
          )}
        >
          {/* Wrapped rather than bare, like every other label here: bare text
              beside a sibling element is what page translation rewrites. */}
          <span>{t(option === "de" ? "lang.de" : "lang.en")}</span>
        </button>
      ))}
    </div>
  );
}
